import React, { useState, useEffect } from 'react'
import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Modal,
  Select,
} from '@material-ui/core'
import { Autocomplete, TextField } from '@mui/material'
import NumberFormat from 'react-number-format'
import {
  getBudgetCategories,
  getTechnicalAssistanceBudgetCategories,
  getTechnicalAssistanceBudgetFindCategory,
} from '../../../../../services/AsistenciaTecnica/get'
import { useAuthentication } from '../../../../../context/authenticationContext'
import { getCurrencyByCountry } from '../../../../../services/Elegibilidad/get'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import swal from 'sweetalert'
import { insertTechnicalAssistanceBudget } from '../../../../../services/AsistenciaTecnica/create'
import { updateTechnicalAssistanceBudget } from '../../../../../services/AsistenciaTecnica/put'
import { deleteITechnicalAssistanceBudget } from '../../../../../services/AsistenciaTecnica/delete'

export const Modal25 = (props) => {
  const {
    open,
    setOpen,
    IdCurrency,
    getTechnicalAssistanceBudgetList,
    action,
    IdTechnicalAssistanceAnswer,
  } = props
  const { userCountry } = useAuthentication()
  const [categories, setCategories] = useState([])
  const [categoriesBudget, setCategoriesBudget] = useState([])
  const [currencyType, setCurrencyType] = useState([])
  const [loading, setLoading] = useState(false)

  const GeneralDataSchema = Yup.object().shape({
    IdCategory: Yup.number()
      .required('Esta campo es obligatorio')
      .typeError('Esta campo es obligatorio'),
    CambioResourceAmount: Yup.number().required('Esta campo es obligatorio'),
    CounterpartAmount: Yup.number().required('Esta campo es obligatorio'),
  })

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      IdTechnicalAssistanceBudget: 0,
      IdTechnicalAssistanceAnswer: IdTechnicalAssistanceAnswer,
      IdCategory: '',
      CambioResourceAmount: '',
      CounterpartAmount: '',
    },
    validationSchema: GeneralDataSchema,
    onSubmit: (values) => {
      saveForm(values)
    },
  })

  const saveForm = async (values) => {
    setLoading(true)
    let response
    if (action === 'add') {
      response = await insertTechnicalAssistanceBudget(values)
    }
    if (action === 'edit') {
      response = await updateTechnicalAssistanceBudget(values)
    }

    if (action === 'delete') {
      response = await deleteITechnicalAssistanceBudget(
        formik.values.IdTechnicalAssistanceBudget,
      )
    }

    if (response.Success) {
      swal({
        title:
          action === 'delete'
            ? '¡Datos eliminados exitosamente!'
            : '¡Datos guardados exitosamente!',
        icon: 'success',
      })
      getTechnicalAssistanceBudgetList()
      getCategoriesTechnicalAssistanceBudget()
      handleClose()
      setLoading(false)
    }
  }

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const getCategories = async () => {
    try {
      const response = await getBudgetCategories()
      if (response.Success) {
        setCategories(response.Data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const findCategories = async (idCategory) => {
    try {
      const response = await getTechnicalAssistanceBudgetFindCategory({
        idForm: IdTechnicalAssistanceAnswer,
        idCategory: idCategory,
      })
      if (response.Success) {
        formik.setValues({
          ...formik.values,
          IdTechnicalAssistanceBudget:
            response.Data.IdTechnicalAssistanceBudget,
          CambioResourceAmount: response.Data.CambioResourceAmount,
          CounterpartAmount: response.Data.CounterpartAmount,
          IdCategory: response.Data.IdCategory,
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getCategoriesTechnicalAssistanceBudget = async () => {
    try {
      const response = await getTechnicalAssistanceBudgetCategories(
        IdTechnicalAssistanceAnswer,
      )
      if (response.Success) {
        setCategoriesBudget(response.Data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  // Función para obtener la moneda por pais
  const getListCurrencyByCountry = async () => {
    try {
      const response = await getCurrencyByCountry(userCountry)
      if (response.Success) {
        setCurrencyType(response.Data)
      } else {
        throw Error(response.Message)
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  const handleClose = () => {
    setOpen(false)
    formik.resetForm()
  }

  useEffect(() => {
    getCategories()
    getCategoriesTechnicalAssistanceBudget()
    getListCurrencyByCountry()
  }, [])

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalPYME">
          <div className="pymeDiv">
            <h1 className="pymeTitle">
              Datos del presupuesto de la Asistencia Técnica
            </h1>
          </div>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Categoría <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                {(() => {
                  let uniqueMitigations = []

                  if (action === 'edit' || action === 'delete') {
                    const icludedIds = categoriesBudget.map(
                      (item) => item.IdCategory,
                    )
                    if (categoriesBudget.length > 0 && categories.length > 0) {
                      uniqueMitigations = categories.filter((item, key) => {
                        return icludedIds.includes(item.IdDataField)
                      })
                    } else {
                      uniqueMitigations = categories
                    }
                  } else {
                    const icludedIds = categoriesBudget.map(
                      (item) => item.IdCategory,
                    )
                    if (categoriesBudget.length > 0 && categories.length > 0) {
                      uniqueMitigations = categories.filter((item, key) => {
                        return !icludedIds.includes(item.IdDataField)
                      })
                    } else {
                      uniqueMitigations = categories
                    }
                  }
                  return (
                    <Autocomplete
                      getOptionLabel={(option) => option.FieldDescription}
                      disablePortal
                      id="combo-box-demo"
                      options={uniqueMitigations}
                      sx={{ width: '100%' }}
                      renderInput={(params) => <TextField {...params} />}
                      onChange={(event, value) => {
                        formik.setFieldValue('IdCategory', value.IdDataField)
                        if (action !== 'add') {
                          findCategories(value.IdDataField)
                        }
                      }}
                    />
                  )
                })()}
                {formik.errors.IdCategory ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.IdCategory}
                  </div>
                ) : null}
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">Moneda</label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                <Select
                  id="IdProject"
                  name="IdProject"
                  variant="outlined"
                  value={IdCurrency}
                  disabled
                >
                  <MenuItem disabled value="">
                    Seleccione una opción
                  </MenuItem>
                  {currencyType &&
                    currencyType.map((item) => (
                      <MenuItem key={item.IdCurrency} value={item.IdCurrency}>
                        {item.Description}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid container spacing={1} className="input__container">
              <Grid item xs={6} sm={6} md={6}>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Monto Recursos Cambio II{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                </Grid>
                <FormControl fullWidth>
                  <NumberFormat
                    id="numberAss"
                    allowLeadingZeros={false}
                    style={{ width: '100%' }}
                    customInput={TextField}
                    thousandSeparator={true}
                    variant="outlined"
                    allowNegative={false}
                    value={formik.values.CambioResourceAmount}
                    onChange={(e) => {
                      formik.setFieldValue(
                        'CambioResourceAmount',
                        Number(e.target.value.replaceAll(',', '')),
                      )
                    }}
                    disabled={action === 'delete'}
                    inputProps={{ maxLength: 12 }}
                    decimalScale={2}
                    fixedDecimalScale
                  />
                  {formik.errors.CambioResourceAmount ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.CambioResourceAmount}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>

              <Grid item xs={6} sm={6} md={6}>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Monto Recursos Contraparte{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                </Grid>
                <FormControl fullWidth>
                  <NumberFormat
                    id="numberAss"
                    allowLeadingZeros={false}
                    style={{ width: '100%' }}
                    customInput={TextField}
                    thousandSeparator={true}
                    variant="outlined"
                    allowNegative={false}
                    value={formik.values.CounterpartAmount}
                    onChange={(e) => {
                      formik.setFieldValue(
                        'CounterpartAmount',
                        Number(e.target.value.replaceAll(',', '')),
                      )
                    }}
                    disabled={action === 'delete'}
                    inputProps={{ maxLength: 12 }}
                    decimalScale={2}
                    fixedDecimalScale
                  />
                  {formik.errors.CounterpartAmount ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.CounterpartAmount}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
            </Grid>

            <Grid className="buttonsPYME">
              <Button className="cancelButton" onClick={handleClose}>
                Cancelar
              </Button>
              <Button
                className="confirmButton"
                onClick={validateFormStatus}
                disabled={loading}
              >
                {action === 'delete' ? 'Eliminar' : 'Guardar'}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  )
}
